module.exports = __webpack_public_path__ + "img/mulitple.612e9f34.png";